import {autocomplete, snippetHit} from '@algolia/autocomplete-js';
import {Fragment} from 'preact';
import {Modal} from 'bootstrap';
import unfetch from 'unfetch';
import debounce from 'debounce-promise';

if(document.getElementById('autocomplete')) {

    document.onkeydown = (event) => {
        if((event.ctrlKey || event.metaKey) && event.key === 's') {
            event.preventDefault();

            document.querySelector('.aa-DetachedSearchButton').dispatchEvent(
                new Event('click')
            );
        }
    }

    const debouncedFetch = debounce(unfetch, 600);
    const cache          = {};

    const { setActiveItemId } = autocomplete({
        container:           '#autocomplete',
        detachedMediaQuery:  '',
        openOnFocus:         true,
        debug:               true,
        placeholder:         document.getElementById('autocomplete').dataset.searchText,
        defaultActiveItemId: 0,
        async getSources({ query }) {
            if(query.trim() === '') {
                return [{
                    sourceId: 'navigationItemsSource',
                    async getItems({ query }) {
                        if(!query.trim()) {
                            if(cache.hasOwnProperty('navigationItems')) {
                                return cache.navigationItems;
                            }
                            const results = await fetch('/api/search/get-navigation')
                                .then((response) => response.json());

                            cache.navigationItems = results;

                            return results;
                        }

                        return [];
                    },
                    getItemUrl({ item }) {
                        return item.url
                    },
                    templates: {
                        header({ items }) {
                            if(items.length === 0) {
                                return null;
                            }
                            return (
                                <Fragment>
                                    <span className="aa-SourceHeaderTitle">{document.getElementById('autocomplete').dataset.quickLinksText}</span>
                                    <div className="aa-SourceHeaderLine" />
                                </Fragment>
                            );
                        },
                        item({ item }) {
                            return (
                                <a className="aa-ItemLink" href={item.url}>
                                    <div className="aa-ItemIcon aa-ItemIcon--no-border">
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                            <polyline points="15 3 21 3 21 9" />
                                            <line x1="10" y1="14" x2="21" y2="3" />
                                        </svg>
                                    </div>

                                    <div className="aa-ItemContent">
                                        <div className="aa-ItemContentTitle">{item.title}</div>
                                    </div>
                                </a>
                            );
                        },
                    }
                }]
            }

            const sources = [];
            if(query.trim() !== '') {
                const results = await debouncedFetch(`/api/search?q=${query}`)
                    .then((response) => response.json())
                    .then((results) => results);

                if(cache.navigationItems[5]) {
                    sources.push({
                        sourceId: 'navigationItemsSource',
                        getItems() {
                            return [];
                        },
                        getItemUrl({ item }) {
                            return item.url
                        },
                        templates: {
                            header({ items }) {
                                if(items.length === 0) {
                                    return null;
                                }
                                return (
                                    <Fragment>
                                        <span className="aa-SourceHeaderTitle">{document.getElementById('autocomplete').dataset.quickLinksText}</span>
                                        <div className="aa-SourceHeaderLine" />
                                    </Fragment>
                                );
                            },
                            item({ item }) {
                                return (
                                    <a className="aa-ItemLink" href={item.url}>
                                        <div className="aa-ItemIcon aa-ItemIcon--no-border">
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                <polyline points="15 3 21 3 21 9" />
                                                <line x1="10" y1="14" x2="21" y2="3" />
                                            </svg>
                                        </div>

                                        <div className="aa-ItemContent">
                                            <div className="aa-ItemContentTitle">{item.title}</div>
                                        </div>
                                    </a>
                                );
                            },
                        }
                    })
                }
                for(let i in results) {
                    if(results[i].results.length > 0) {
                        sources.push({
                            sourceId: results[i].sourceId,
                            getItems() {
                                return results[i].results;
                            },
                            getItemUrl({ item }) {
                                return item.url;
                            },
                            templates: {
                                header({ items }) {
                                    if(items.length === 0) {
                                        return null;
                                    }
                                    return (
                                        <Fragment>
                                            <span className="aa-SourceHeaderTitle">{results[i].sourceName}</span>
                                            <div className="aa-SourceHeaderLine" />
                                        </Fragment>
                                    );
                                },
                                item({ item }) {
                                    return <SearchItem hit={item} />
                                },
                            }
                        });
                    }
                }
            }

            setActiveItemId(1);
            return sources;
        },
        navigator: {
            navigate({ item }) {
                window.location.assign(item.url);
            },
            navigateNewTab({ item }) {
                window.location.assign(item.url);
            },
            navigateNewWindow({ item }) {
                window.location.assign(item.url);
            },
        },
    });

    function SearchItem({ hit }) {
        return (
            <Fragment>
                {hit.image !== null && <div className="aa-ItemImage" onClick={(event) => {
                    window.location.assign(hit.url);
                }}>
                    <img src={hit.image} alt={hit.title} width="80" />
                </div>}
                <div className="aa-ItemContent" onClick={(event) => {
                    window.location.assign(hit.url);
                }}>
                    <div className="aa-ItemContentTitle">
                        {snippetHit({
                            hit,
                            attribute: 'title',
                        })}
                    </div>
                    {hit.article_code && <div className="aa-ItemContentDescription text-xs" onClick={(event) => {
                        window.location.assign(hit.url);
                    }}>
                        {snippetHit({
                            hit,
                            attribute: 'article_code',
                        })}
                    </div>}
                    {hit.function && <div className="aa-ItemContentDescription text-xs" onClick={(event) => {
                        window.location.assign(hit.url);
                    }}>
                        {snippetHit({
                            hit,
                            attribute: 'function',
                        })}
                    </div>}
                    <div className="aa-ItemContentDescription" onClick={(event) => {
                        window.location.assign(hit.url);
                    }}>
                        {snippetHit({
                            hit,
                            attribute: 'description',
                        })}
                    </div>
                </div>
                <div className="aa-ItemActions" onClick={(event) => {
                    window.location.assign(hit.url);
                }}>
                    <button
                        className="aa-ItemActionButton aa-TouchOnly aa-ActiveOnly"
                        type="button"
                        title="Select"
                    >
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                            <path d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z" />
                        </svg>
                    </button>
                </div>
            </Fragment>
        );
    }
}